export default __webpack_public_path__ + "static/media/SimuTGD2Logo.46bfef3e.svg";